import React from 'react';
import ErrorPages from './ErrorPages';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to your error reporting service
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPages type="server" onHomeClick={() => window.location.href = '/'} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;